const ZincCoating = {
	None: 0,
	HotDip: 1,
	Galvanize: 2,
	Both: 3, // Only exists in frontend
};

export const getZincCoatingText = (zincCoating) => {
	const coatingMap = {
		[ZincCoating.None]: "Nein",
		[ZincCoating.HotDip]: "Feuerverzinkt",
		[ZincCoating.Galvanize]: "Galvanisch Verzinkt",
		[ZincCoating.Both]: "Galv. und Feuerverzinkung",
	};

	return coatingMap[zincCoating] != undefined ? coatingMap[zincCoating] : "n/a";
};
